export default __webpack_public_path__ + "static/media/Espece-protegee.f467ef5d.svg";